import React from 'react';
import { Calendar } from 'primereact/calendar';

import { convertDateToLocaleString } from '../../../utils/Helpers';
import { convertDateToClientZuluTime } from '../../../utils/date.helper';

export default function PFCalendar({
  id,
  value,
  onChange,
  placeholder,
  name,
  disabled,
  className,
  showTime = undefined,
  hourFormat = undefined,
  appendTo = 'self',
  minDate,
  dateFormat,
  maxDate,
  ...props
}) {
  return (
    <Calendar
      id={id || ''}
      value={
        value && props?.isClientTimeZone
          ? new Date(convertDateToLocaleString(value))
          : (value ?? null)
      }
      name={name || ''}
      onChange={e => {
        e.target.value =
          e.target.value && props?.isClientTimeZone
            ? convertDateToClientZuluTime(e.target.value)
            : e.target.value;
        onChange(e);
      }}
      className={`w-full ${className || ''}`}
      placeholder={placeholder || ''}
      appendTo={appendTo === null ? null : appendTo}
      disabled={!!disabled}
      showTime={showTime}
      hourFormat={hourFormat}
      minDate={minDate ?? null}
      maxDate={maxDate ?? null}
      dateFormat={dateFormat || 'mm-dd-yy'}
      inputClassName="p-inputtext-sm"
      {...props}
    />
  );
}
